import React from 'react';
import { AwesomeButton } from 'react-awesome-button';
import { feedbackOptions } from '../../utils/constants';
import { FeedbackData } from '../../types';

interface FeedbackFormProps {
  feedback: any;
  onFeedbackChange: (name: string, value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  error?: string;
  setIsFeedbackModalOpen: (isOpen: boolean) => void;
}

export const FeedbackForm: React.FC<FeedbackFormProps> = ({
  feedback,
  onFeedbackChange,
  onSubmit,
  error,
  setIsFeedbackModalOpen
}) => {
  const handleCloseFeedbackModal = () => {
    setIsFeedbackModalOpen(false);
  };

  return (
    <form onSubmit={onSubmit} className="modal-form">
      <h2>We would love to hear your feedback!</h2>
      <button 
        type="button" 
        onClick={handleCloseFeedbackModal} 
        className="close-modal-btn"
      >
        &times;
      </button>
      <p>How would you rate the last task we generated?</p>
      {error && (
        <div className="error-message" style={{ color: 'red' }}>
          {error}
        </div>
      )}
      {Object.entries(feedbackOptions).map(([key, options]) => (
        <div className="feedback-item" key={key}>
          <label className="feedback-label">{key.charAt(0).toUpperCase() + key.slice(1)}<sup>*</sup></label>
          <select
            name={key}
            value={feedback[key as keyof typeof feedback]}
            onChange={(e) => onFeedbackChange(key, e.target.value)}
            required
            style={{ width: '250px' }}
          >
            <option value="">Select an option</option>
            {options.map((option) => (
              <option key={option.label} value={option.label}>{option.label}</option>
            ))}
          </select>
        </div>
      ))}
      <div className="comments-section">
        <label>Comments:</label>
        <textarea
          name="comments"
          value={feedback.comments}
          onChange={(e) => onFeedbackChange('comments', e.target.value)}
          placeholder="Tell us more about your experience on the task :-)"
        />
      </div>
      <AwesomeButton
        type="primary"
        className="submit-feedback-btn"
      >
        <span className="button-content">
          <span className="larger-bold-text">Submit Feedback & Finish</span>
        </span>
      </AwesomeButton>
    </form>
  );
};